import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

import { openNavStyles } from '@/components/modules/app-navigation/open';
import {
  accordionChevronIconVariants,
  iconVariants,
  navItemVariants,
} from '@/components/modules/app-navigation/utils/transitions';
import { NotificationDot } from '@/components/ui/notification-dot';

interface OpenItemHeaderContentProps {
  label: string;
  parentIsActive?: boolean;
  visibility: 'visible' | 'hidden';
  iconComponent: any;
  isOpen?: boolean;
  showNotificationDot?: boolean;
  notificationContent?: string;
  hasSubItems?: boolean;
  hideIcon?: boolean;
}

const OpenItemHeaderContent = ({
  label,
  isOpen,
  visibility,
  iconComponent,
  parentIsActive,
  showNotificationDot,
  notificationContent,
  hasSubItems,
  hideIcon,
}: OpenItemHeaderContentProps) => {
  const Icon = iconComponent;

  const { icon, triggerContent, triggerIcon, notificationWrapper } = openNavStyles({
    isOpen,
  });

  return (
    <span className={triggerContent()}>
      <motion.span
        variants={iconVariants}
        animate={visibility}
        initial={hideIcon ? 'hidden' : visibility}
        className="h-5"
      >
        <Icon className={icon({ className: parentIsActive ? 'text-white' : '' })} />
      </motion.span>
      <motion.span variants={navItemVariants} animate={visibility} initial={visibility}>
        <span className="ml-2.5">{label}</span>
      </motion.span>
      {hasSubItems && (
        <motion.span variants={accordionChevronIconVariants} animate={visibility} className="ml-auto">
          <ChevronDown className={triggerIcon()} />
        </motion.span>
      )}
      {showNotificationDot ? (
        <div className={notificationWrapper()}>
          <NotificationDot tooltipContent={notificationContent} />
        </div>
      ) : null}
    </span>
  );
};

export { OpenItemHeaderContent };
